module.exports = __webpack_public_path__ + "static/media/CONGRATS@2x.a70ab4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/CONGRATS@2x.png
// module id = 272
// module chunks = 0